(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lash-premium"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function enhance(marker) {
      const root = document.querySelector('lash-configurator');
      if (!root || !root.state || root.dataset.premiumReady) return;
      const box = root.querySelector('.lc__box');
      const groups = [root.querySelector('[data-setpick]'), root.querySelector('.lc__group--style'), root.querySelector('[data-length-group="1"]')];
      if (!box || groups.some(group => !group)) return;
      root.dataset.premiumReady = 'true';
      box.id = 'lash-premium-configurator';
      const strings = marker.dataset;
      const steps = [];
      const make = (tag, className, text) => {
        const node = document.createElement(tag);
        if (className) node.className = className;
        if (text) node.textContent = text;
        return node;
      };
      // De rustplek van een stapkop: net onder de plakkende header, zodat hij niet half wegvalt.
      function restingTop() {
        const header = document.querySelector('sticky-header, .header-wrapper');
        return (header ? header.getBoundingClientRect().height : 0) + 16;
      }
      // 16-09 (opdracht Thomas): stapwissel sprong tot ~950 pixels, want het vorige paneel klapt
      // dicht en daarna werd er hard naar de nieuwe stap gesprongen. Nu houden we de aangeklikte
      // kop eerst op precies dezelfde plek in beeld (die correctie ziet de klant niet) en laten we
      // hem daarna rustig naar zijn rustplek glijden. Staat de kop niet in beeld, dan is er niets
      // te bevriezen en plaatsen we hem meteen.
      function open(index, focus = false) {
        const head = steps[index].toggle;
        const before = focus ? head.getBoundingClientRect() : null;
        const inView = !!before && before.bottom > 0 && before.top < window.innerHeight;
        const topBefore = before ? before.top : 0;
        steps.forEach((step, i) => {
          step.toggle.setAttribute('aria-expanded', String(i === index));
          step.panel.hidden = i !== index;
        });
        if (!focus) return;
        head.focus({ preventScroll: true });
        if (inView) {
          const shifted = head.getBoundingClientRect().top - topBefore;
          if (shifted) window.scrollBy({ top: shifted, behavior: 'instant' });
        }
        const remaining = head.getBoundingClientRect().top - restingTop();
        if (Math.abs(remaining) < 4) return;
        const gentle = inView && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollBy({ top: remaining, behavior: gentle ? 'smooth' : 'instant' });
      }
      groups.forEach((group, index) => {
        const section = make('section', 'lp-step');
        const heading = make('h3', 'lp-step__heading');
        const toggle = make('button', 'lp-step__toggle');
        toggle.type = 'button';
        toggle.id = 'lp-toggle-' + root.dataset.sectionId + '-' + index;
        const panel = make('div', 'lp-step__panel');
        panel.id = 'lp-panel-' + root.dataset.sectionId + '-' + index;
        panel.setAttribute('role', 'region');
        panel.setAttribute('aria-labelledby', toggle.id);
        toggle.setAttribute('aria-controls', panel.id);
        const number = make('span', 'lp-step__number', String(index + 1));
        number.setAttribute('aria-hidden', 'true');
        const copy = make('span');
        copy.append(make('span', 'lp-step__title', [strings.kit, strings.style, strings.length][index]));
        const summary = make('span', 'lp-step__summary');
        copy.append(summary);
        const icon = make('span', 'lp-step__icon');
        icon.setAttribute('aria-hidden', 'true');
        toggle.append(number, copy, icon);
        heading.append(toggle);
        group.before(section);
        section.append(heading, panel);
        panel.append(group);
        steps.push({ section, toggle, panel, summary });
        toggle.addEventListener('click', () => open(index, true));
        if (index < 2) {
          const next = make('button', 'lp-step__next', index === 0 ? strings.nextStyle : strings.nextLength);
          next.type = 'button';
          const arrow = make('span', '', '→');
          arrow.setAttribute('aria-hidden', 'true');
          next.append(arrow);
          next.addEventListener('click', () => open(index + 1, true));
          panel.append(next);
        }
      });
      const length2 = root.querySelector('[data-length-group="2"]');
      if (length2) steps[2].panel.append(length2);
      const help = root.querySelector('.lc__choice-help');
      if (help) steps[2].panel.append(help);
      const lengthNote = make('p', 'lp-length-note', strings.twoLengths);
      steps[2].panel.prepend(lengthNote);
      const single = root.querySelector('[data-set-label="single"]');
      if (single) single.append(make('span', 'lp-single-note', strings.single));
      // 16-09: lege tekst betekent geen regel, zodat hij via de vertaling uit kan
      if (strings.priceNote) groups[0].append(make('p', 'lp-price-note', strings.priceNote));
      function sync() {
        const kit = root.querySelector('[data-set-label="' + root.state.set + '"]');
        const title = kit?.querySelector('.lc__set-title')?.textContent.trim() || '';
        const price = kit?.querySelector('[data-set-price]')?.textContent.trim() || '';
        const style = root.currentStyle().title;
        const two = length2 && !length2.hidden;
        const length = two ? root.state.length + ' + ' + root.state.length2 + ' mm' : root.state.length + ' mm';
        const write = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
        write(steps[0].summary, title + (price ? ' · ' + price : ''));
        write(steps[1].summary, style);
        write(steps[2].summary, length);
        write(root.querySelector('[data-sticky-summary]'), title + ' · ' + style + ' · ' + length);
        lengthNote.hidden = !two;
      }
      root.addEventListener('change', () => queueMicrotask(sync));
      const observer = new MutationObserver(sync);
      observer.observe(root, { attributes: true, attributeFilter: ['data-set', 'data-style', 'data-length', 'data-state'] });
      marker._observer = observer;
      open(0);
      sync();
    }
    const init = () => customElements.whenDefined('lash-configurator').then(() => {
      document.querySelectorAll('lash-premium').forEach(enhance);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll('lash-premium').forEach(marker => marker._observer?.disconnect());
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
